import moneyToString from "@shared/utils/formatters/moneyToString"
import { PremiumBand } from "../../policies/api/useFindPolicy"

export type Data = Omit<PremiumBand, "abiGroupConstraint" | "minPerMileCost" | "fixedGrossPremium"> & {
  fixedGrossPremium: string
}

export const data = (premiumBand: ReadonlyArray<PremiumBand>) =>
  premiumBand.map((it) => ({
    ...it,
    minPerMileCost: `${moneyToString(it.minPerMileCost)} - ${moneyToString(it.maxPerMileCost)}`,
    fixedGrossPremium: moneyToString(it.fixedGrossPremium),
  }))
